export var UserType;
(function (UserType) {
    UserType["BASIC"] = "basic";
    UserType["ADMIN"] = "admin";
    UserType["INTERNAL"] = "internal";
})(UserType || (UserType = {}));
//# sourceMappingURL=user-type.enum.js.map